import React from 'react';
import { cn } from '../../utils/cn';

export function SectionPanel({ className, ...props }: React.ComponentPropsWithoutRef<'section'>) {
  return (
    <section
      className={cn('rounded-2xl border border-ink-200 bg-white shadow-panel', className)}
      {...props}
    />
  );
}
